import { render, staticRenderFns } from "./room-form.vue?vue&type=template&id=730168ca&"
import script from "./room-form.vue?vue&type=script&lang=ts&"
export * from "./room-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports